// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/axios'
import './utils/validate'
import {required, num} from "@/utils/validate";
import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
import Index from './components/Index.vue';
import { Button } from "element-ui";
import "./element.js";
//设置反向代理，前端请求默认发送到 http://前端ip地址:你的前端端口/api
var axios = require('axios')
axios.defaults.baseURL = '/api'

Vue.config.productionTip = false
Vue.use(ElementUI); // 3.安装
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(Index)
});



// WEBPACK FOOTER //
// ./src/main.js